module.exports = {
  SelectReconciliationRules: 'Chọn quy tắc đối chiếu',
  ReturnToReconciliationNewVersion: 'Quay lại phiên bản đối chiếu mới',
  StartReconciliation: 'Bắt đầu đối chiếu',
  Save: 'Lưu',
  ManualReconciliation: 'Đối chiếu thủ công',
  CancelManualReconciliation: 'Hủy đối chiếu thủ công',
  ShowAllReconciliationCost: 'Hiển thị tất cả chi phí đối chiếu',
  ShowConsistentReconciliationCost: 'Hiển thị chi phí đối chiếu khớp',
  ShowPartiallyConsistentReconciliationFees: 'Hiển thị chi phí đối chiếu khớp một phần',
  ShowUnmatchedCosts: 'Hiển thị chi phí chưa khớp',
  Note: 'Giải thích:',
  Green: 'Màu xanh lá',
  IndicatesConsistentReconciliationResults: 'Biểu thị kết quả đối chiếu khớp;',
  Black: 'Màu đen',
  IndicatesNoCorrespondingChargeFound: 'Biểu thị không tìm thấy chi phí tương ứng;',
  Red: 'Màu đỏ',
  IndicatesInconsistentAmounts: 'Biểu thị số tiền không khớp;',
  Orange: 'Màu cam',
  IndicatesManualReconciliationComplete: 'Biểu thị đối chiếu thủ công hoàn thành;',
  IfEtcPleaseGoModule: 'Nếu cần xử lý chênh lệch, vui lòng đến mô-đun đối chiếu phiên bản mới.',
  ImportExternalCharges: 'Nhập chi phí bên ngoài',
  InternalSystemCharges: 'Chi phí nội bộ hệ thống',
  IfMaintainReconciliationRulesClick: 'Nếu cần bảo trì quy tắc đối chiếu, vui lòng nhấp vào',
  ReconciliationRuleEngineConfiguration: 'Cấu hình công cụ quy tắc đối chiếu.',
  ReconciliationConsistent: 'Đối chiếu khớp',
  Items: 'điều',
  InconsistentAmounts: 'Số tiền không khớp',
  CorrespondingChargesNotFound: 'Không tìm thấy chi phí tương ứng',
  ImportSucceeded: 'Nhập thành công',
  CancelAllManualReconciliations: 'Hủy tất cả đối chiếu thủ công',
  ExportAllComparisonResults: 'Xuất tất cả kết quả so sánh',
  ExportConsistentComparisonResults: 'Xuất kết quả so sánh khớp',
  ExportDiscrepancyComparisonResults: 'Xuất kết quả so sánh chênh lệch',
  BusinessNumber: 'Mã nghiệp vụ',
  ShipName: 'Tên tàu',
  VoyageNumber: 'Chuyến đi',
  ContainerNumber: 'Số container',
  ConfirmationStatus: 'Trạng thái xác nhận',
  ChargeName: 'Tên chi phí',
  Currency: 'Loại tiền tệ',
  PriceIncludingTax: 'Giá bao gồm thuế',
  PriceExcludingTax: 'Giá không bao gồm thuế',
  TaxRate: 'Thuế suất',
  TaxAmount: 'Số tiền thuế',
  Difference: 'Chênh lệch',
  ReconciliationAmount: 'Số tiền đối chiếu',
  UnitPrice: 'Đơn giá',
  Quantity: 'Số lượng',
  InvoiceNumber: 'Số hóa đơn',
  ReconciliationResult: 'Kết quả đối chiếu',
  ReconciliationRuleName: 'Tên quy tắc đối chiếu',
  ComparisonOrder: 'Thứ tự so sánh',
  PleaseNeedToBeReconciliation: 'Vui lòng chọn các khoản phí cần đối chiếu trước khi thực hiện đối chiếu thủ công.',
  ManualReconciliationSucceeded: 'Đối chiếu thủ công thành công',
  AreCancelAllManualTime: 'Bạn có chắc chắn muốn hủy toàn bộ thông tin đối chiếu thủ công lần này?',
  Tips: 'Thông báo',
  Yes: 'Có',
  No: 'Không',
  CancelAllManualReconciliationsSuccessful: 'Hủy toàn bộ đối chiếu thủ công thành công',
  RequestSucceededExporting: 'Yêu cầu thành công, đang xuất dữ liệu!',
  SavedSuccessfully: 'Lưu thành công',
  PleaseUseAndFillNumbers: 'Vui lòng chọn quy tắc đối chiếu cần sử dụng và nhập thứ tự so sánh bằng số',
  Unconfirmed: 'Chưa xác nhận',
  Confirmed: 'Đã xác nhận',
  ViewDetails: 'Xem chi tiết',
  Return: 'Quay lại',
  ShowAllReconciliationFees: 'Hiển thị tất cả khoản phí đối chiếu',
  ShowFullyReconciledFees: 'Hiển thị khoản phí đối chiếu khớp',
  ShowPartiallyReconciledFees: 'Hiển thị khoản phí đối chiếu khớp một phần',
  ShowUnmatchedFees: 'Hiển thị khoản phí chưa khớp',
  IndicatesReconciliationResultIsConsistent: 'Biểu thị kết quả đối chiếu khớp;',
  IndicatesCorrespondingFeeNotFound: 'Biểu thị không tìm thấy khoản phí tương ứng;',
  IndicatesAmountInconsistency: 'Biểu thị số tiền không khớp;',
  IndicatesManualReconciliationCompleted: 'Biểu thị đối chiếu thủ công hoàn tất;',
  ImportExternalFees: 'Nhập khoản phí bên ngoài',
  SystemInternalFees: 'Khoản phí nội bộ hệ thống',
  ViewFile: 'Xem tệp',
  System: 'Hệ thống',
  Voyage: 'Chuyến bay',
  FeeName: 'Tên khoản phí',
  TaxIncludedPrice: 'Giá bao gồm thuế',
  TaxExcludedPrice: 'Giá không bao gồm thuế',
  PleaseSelectOneRecord: 'Vui lòng chọn một bản ghi.',
  All: 'Tất cả',
  BankName: 'Tên ngân hàng',
  YouPermissionToViewData: 'Bạn không có quyền xem dữ liệu này',
  QuickRetrieval: 'Tìm kiếm nhanh:',
  Selected: 'Đã chọn',
  QuickRetrievalBillNumber: 'Tìm kiếm nhanh: Số hóa đơn',
  BillClaims: 'Nhận biên lai',
  FinancialReview: 'Kiểm tra tài chính',
  QuickRetrievalBusinessNumber: 'Tìm kiếm nhanh: Mã nghiệp vụ',
  QuickRetrievalWaterBillNumber: 'Tìm kiếm nhanh: Số biên lai',
  WaterBillClaims: 'Nhận biên lai',
  Unused: 'Chưa sử dụng',
  PleaseAWaterBillRecord: 'Vui lòng chọn bản ghi biên lai.',
  WaterReleasedAndCannotModified: 'Biên lai đã được phát hành, không thể chỉnh sửa.',
  WaterClaimedAndCannotModified: 'Biên lai đã được nhận, không thể chỉnh sửa.',
  WaterReturnedAndCannotModified: 'Biên lai đã bị trả lại, không thể chỉnh sửa.',
  WaterRecordsAndCannotVoided: 'Biên lai đã có bản ghi thanh toán, không thể hủy.',
  WaterToFinancialVoucherVoided: 'Biên lai đã xuất chứng từ kế toán, không thể hủy bỏ.',
  Confirm: 'Xác nhận',
  Cancel: 'Hủy bỏ',
  NoBillRecordsToRelease: 'Không có bản ghi biên lai cần phát hành.',
  NoRecordsToCancelRelease: 'Không có bản ghi biên lai cần hủy phát hành.',
  OnlyCanRevokeTheBill: 'Chỉ người thanh toán mới có thể thu hồi biên lai.',
  WaterCannotBeRevokedFirst: 'Biên lai đã kiểm tra không thể thu hồi, vui lòng hủy kiểm tra trước.',
  ThisPleaseDeleteTheAgain: 'Biên lai này đã tạo chứng từ kế toán, vui lòng xóa chứng từ trước khi thu hồi.',
  WaterBillRevocationSuccessful: 'Thu hồi biên lai thành công.',
  WaterBillRegistration: 'Đăng ký biên lai',
  WaterBillNotSelected: 'Chưa chọn biên lai.',
  AdvanceNoAdvancePaymentGenerated: 'Đã nhận tiền tạm ứng nhưng chưa tạo chứng từ tạm ứng.',
  Claimed: 'Đã nhận',
  ReceivableClaimCompleted: 'Đã nhận khoản phải thu.',
  PrepaymentClaimCompleted: 'Đã nhận tiền tạm ứng.',
  NoInTheCurrentBill: 'Biên lai hiện tại không có số tiền nhận dư.',
  PleaseDataToBeClaimed: 'Vui lòng chọn dữ liệu cần nhận.',
  DomesticBill: 'Hóa đơn nội địa',
  InvoicingMetForReconciliationStatus: 'Trạng thái bảng đối chiếu không đủ điều kiện lập hóa đơn!',
  AddToBillQueryList: 'Thêm vào danh sách tra cứu hóa đơn',
  ForeignBill: 'Hóa đơn quốc tế',
  AgencyCommissionBill: 'Hóa đơn chia phần đại lý',
  Bill: 'Hóa đơn:',
  CreatePaymentRequestSelectFee: 'Tạo yêu cầu thanh toán - Chọn chi phí',
  SettlementTheBillCannotEmpty: 'Đại lý thanh toán hóa đơn không được để trống!',
  CreatePaymentRequestDetailedInformation: 'Tạo yêu cầu thanh toán - Thông tin chi tiết',
  ReconciliationBill: 'Bảng đối chiếu',
  QuickRetrievalReconciliationBillNumber: 'Tra cứu nhanh: Số bảng đối chiếu',
  Payable: '(Phải trả)',
  Receivable: '(Phải thu)',
  ReconciliationByFee: 'Đối chiếu - Theo chi phí',
  ReconciliationByBusiness: 'Đối chiếu - Theo nghiệp vụ',
  SelectImportTemplateSolution: 'Chọn phương án mẫu nhập liệu',
  Prompt: 'Thông báo',
  TemplateSolutionName: 'Tên phương án mẫu',
  ToMaintainImportTemplatesClick: 'Nếu cần bảo trì mẫu nhập liệu, vui lòng nhấp',
  BasicDataImportTemplateSolutions: 'Dữ liệu cơ bản - Phương án mẫu nhập liệu.',
  PleaseSelectASolution: 'Vui lòng chọn phương án',
  PleaseSettlementUnitBeforeImporting: 'Vui lòng tra cứu đơn vị thanh toán trước khi nhập',
  NoFoundNoNeedReconcile: 'Không tìm thấy chi phí liên quan, không cần đối chiếu',
  PleaseBasicDataImportSolution: 'Vui lòng đến phần phương án mẫu nhập liệu trong dữ liệu cơ bản để bảo trì',
  ImportErrorPleaseReImport: 'Định dạng nhập liệu sai, vui lòng nhập lại',
  PleaseSelectATemplate: 'Vui lòng chọn mẫu',
  YouHavePermissionToOpen: 'Bạn không có quyền mở',
  Module: 'Quyền truy cập module',
  ViewPaymentRequestForm: 'Xem phiếu yêu cầu thanh toán',
  CreatingFormFailedPleaseAgain: 'Tạo phiếu yêu cầu thanh toán thất bại, vui lòng lưu lại!',
  ShanghaiAirFreightPayment: 'Thanh toán vận chuyển hàng không Thượng Hải',
  PaymentRequestDirect: 'Yêu cầu thanh toán trực tiếp',
  IncludesReSelectPaymentNumber: 'Bao gồm chi phí đã lập hóa đơn, vui lòng chọn lại! Số phiếu yêu cầu thanh toán:',
  CantDirectlyChangeConfigurationAgain: 'Không thể kiểm tra tài chính trực tiếp, vui lòng thay đổi cấu hình và thử lại!',
  Invoicing: 'Xuất hóa đơn',
  QueryMethod: 'Phương thức tra cứu',
  ByFee: 'Theo chi phí',
  ByBusiness: 'Theo nghiệp vụ',
  IncludeReceivables: 'Bao gồm phải thu',
  NoteFilteredOutFullyBusiness: 'Lưu ý: Giao diện này đã lọc bỏ các nghiệp vụ chi phí đã thanh toán hoàn toàn',
  ConvertedToRMB: 'Quy đổi RMB:',
  NextStep: 'Bước tiếp theo',
  NotFound: 'Không tìm thấy',
  CorrespondingPrintTemplate: 'Mẫu in tương ứng',
  WarehouseEntryNumber: 'Số nhập kho',
  BookingNumber: 'Số đặt chỗ',
  CutOffDate: 'Ngày chốt đơn',
  ProjectNumber: 'Số dự án',
  OverseasCustomerService: 'Dịch vụ khách hàng hải ngoại',
  PaymentApplicationNumber: 'Số đơn yêu cầu thanh toán',
  BillNumber: 'Số hóa đơn',
  SettlementObject: 'Đối tượng thanh toán',
  PickUpType: 'Loại nhận hàng',
  MasterBillNumber: 'Số vận đơn chính',
  HouseBillNumber: 'Số vận đơn phụ',
  EntrustingUnit: 'Đơn vị ủy thác',
  BusinessType: 'Loại nghiệp vụ',
  BusinessDate: 'Ngày nghiệp vụ',
  VesselVoyage: 'Tên tàu/chuyến',
  DeparturePort: 'Cảng đi',
  DestinationPort: 'Cảng đến',
  StartingStation: 'Ga xuất phát',
  TerminusStation: 'Ga đích',
  TransitStation: 'Ga quá cảnh',
  DestinationPortAgent: 'Đại lý cảng đến',
  Sales: 'Kinh doanh',
  Operation: 'Vận hành',
  CustomerService: 'Dịch vụ khách hàng',
  Documentation: 'Chứng từ',
  BusinessReferenceNumber: 'Số tham chiếu nghiệp vụ',
  CustomBusinessType: 'Loại nghiệp vụ tùy chỉnh',
  Accrued: 'Đã trích lập',
  FinancialDate: 'Ngày tài chính',
  DomesticForeign: 'Nội địa/Quốc tế',
  IncomeAndExpensesType: 'Loại thu chi',
  ExpenseStatus: 'Trạng thái chi phí',
  Auditor: 'Người kiểm duyệt',
  ExpenseName: 'Tên chi phí',
  Unit: 'Đơn vị',
  WriteOffAmount: 'Số tiền thanh toán',
  UnwrittenOffAmount: 'Số tiền chưa thanh toán',
  ContactPerson: 'Người liên hệ',
  Creator: 'Người tạo',
  CreationDate: 'Ngày tạo',
  Remark: 'Ghi chú',
  CorrelationNumber: 'Số liên quan giao dịch',
  DelegationCorrelationNumber: 'Số liên quan ủy thác',
  Carrier: 'Người vận chuyển',
  ConfirmationDate: 'Ngày xác nhận',
  ExpenseConfirmer: 'Người xác nhận chi phí',
  RouteResponsiblePerson: 'Người phụ trách tuyến đường',
  BillingDate: 'Ngày lập hóa đơn',
  BillingHeader: 'Tên trên hóa đơn',
  NeedForInvoicing: 'Có cần lập hóa đơn không',
  ConfirmationRemark: 'Ghi chú xác nhận',
  AccountingDate: 'Ngày thanh toán',
  BusinessStatus: 'Trạng thái nghiệp vụ',
  CustomField1: 'Trường tùy chỉnh 1',
  CustomField2: 'Trường tùy chỉnh 2',
  CustomField3: 'Trường tùy chỉnh 3',
  ReceiptAndPaymentDate: 'Ngày thu/chi',
  SalesDepartment: 'Phòng kinh doanh',
  ChooseExpense: 'Chọn chi phí',
  CreatePaymentApplicationChooseExpense: 'Tạo yêu cầu thanh toán - Chọn chi phí',
  Other: 'Khác',
  YouViewOrPrintOthers: 'Bạn không có quyền xem tệp người khác tải lên hoặc in.',
  BookingAgent: 'Đại lý đặt chỗ',
  PleaseSelect: 'Vui lòng chọn yêu cầu',
  ProvisionalBusinesses: 'Nghiệp vụ trích lập',
  ChangeOrderApprovalSuccess: 'Duyệt sửa đơn thành công',
  ThisIsNotForProvision: 'Nghiệp vụ này không phải chờ trích lập, không thể trích lập!',
  ForPleaseChooseProvisionedBusiness: 'Chưa trích lập, vui lòng chọn nghiệp vụ đã trích lập!',
  FrontendErrorCallbackFailed: 'Lỗi frontend: Gọi lại thất bại',
  RouteManager: 'Người phụ trách tuyến đường',
  ThisFieldCannotBeEmpty: 'Mục này không được để trống',
  OperationAllowedToBeEmpty: 'Thao tác không được để trống',
  OperatingAllowedToBeEmpty2: 'Phòng ban thao tác không được để trống',
  OperatingAllowedToBeEmpty3: 'Chi nhánh thao tác không được để trống',
  DesignatedFreightForwarder: 'Đại lý hàng chỉ định',
  OriginPortAgent: 'Đại lý cảng đi',
  TransportationCompany: 'Công ty vận tải',
  Warehouse: 'Kho hàng',
  CustomsBroker: 'Hải quan',
  CustomsDeclaration: 'Có thông quan không',
  PickingStorage: 'Đóng gói nội bộ/Kho bãi',
  Storage: 'Có lưu kho không',
  CargoType: 'Loại nhận hàng',
  ActualBillingWeight: 'Trọng lượng tính phí thực tế',
  QuotationNature: 'Tính chất giá ước tính',
  BookingType: 'Tính chất đặt chỗ',
  AllWriteOffs: 'Xóa sổ toàn bộ',
  BusinessCannotBeEmpty: 'Nghiệp vụ không được để trống!',
  ReviewSuccess: 'Duyệt thành công',
  ReviewFailed: 'Kiểm tra không thành công',
  ColumnDataConversionRendering: 'Chuyển đổi và hiển thị dữ liệu cột:',
  SelectActualReceiptAndPayment: 'Chọn thực thu thực chi',
  SingleWriteOffDetailXls: 'Chi tiết thanh toán đơn lẻ.xls',
  SentOut: 'Đã gửi đi!',
  FetchDate: 'Ngày lấy lại',
  ReturnDate: 'Ngày hoàn trả',
  DeclarationDate: 'Ngày khai báo',
  SailingDate: 'Ngày tàu khởi hành',
  OperationDate: 'Ngày thao tác',
  Contracted: 'Đã ký hợp đồng',
  ContractExpired: 'Hợp đồng hết hiệu lực',
  Uncontracted: 'Chưa ký hợp đồng',
  ViewReturnOrderFiles: 'Xem tệp đơn hoàn trả',
  OnlyWithTheSameStatus: 'Chỉ được in chứng từ có cùng trạng thái.',
  HouseWaybillNumber: 'Số đơn phụ',
  RevokeFetch: 'Hủy lấy lại',
  SentOutDate: 'Ngày gửi đi',
  ProvisionedBusiness: 'Nghiệp vụ trích lập',
  ForPleaseChooseUnprovisionedBusiness: 'Đã được trích lập, vui lòng chọn nghiệp vụ chưa trích lập!',
  ProvisionSuccess: 'Trích lập thành công',
  CancellationProvisionsSuccess: 'Hủy trích lập thành công',
  ProvisionReview: 'Kiểm tra trích lập',
  ProvisionDate: 'Ngày trích lập',
  Booking: 'Đặt chỗ',
  CustomsClearance: 'Khai báo hải quan',
  FormalHouseWaybill: 'Đơn phụ hình thức',
  CommodityInspection: 'Kiểm dịch thương mại',
  Fumigation: 'Xông hơi',
  ForeignTrade: 'Ngoại thương',
  CustomerAttribute: 'Thuộc tính khách hàng',
  Dropdown: 'Kéo xuống',
  OrderChannel: 'Kênh đơn hàng',
  ArrivalDate: 'Ngày cập cảng',
  ShippingOfBillOfLading: 'Nơi giao hàng trên vận đơn',
  OriginPortPOL: 'Cảng xếp hàng (POL)',
  DeliveryPlace: 'Nơi giao hàng',
  Route: 'Tuyến đường',
  FinalDestination: 'Điểm đến cuối cùng',
  ShippingCompany: 'Công ty tàu biển',
  ShipAgent: 'Đại lý tàu',
  TradeMethod: 'Phương thức thương mại',
  MasterWaybillTransportTerms: 'Điều khoản vận chuyển đơn chính',
  HouseWaybillTransportTerms: 'Điều khoản vận chuyển đơn phụ',
  MasterWaybillFreightTerms: 'Điều khoản cước phí đơn chính',
  MasterWaybillPaymentLocation: 'Nơi thanh toán đơn chính',
  HouseWaybillFreightTerms: 'Điều khoản cước phí đơn phụ',
  HouseWaybillPaymentLocation: 'Nơi thanh toán đơn phụ',
  TradeTerms: 'Điều khoản thương mại',
  CargoDimensions: 'Kích thước hàng hóa',
  SpecialPriceExplanation: 'Giải thích khuyến mãi',
  GrossWeightEntrustedActual: 'Trọng lượng gộp (Ủy/Thực)',
  VolumeEntrustedActual: 'Thể tích (Ủy/Thực)',
  Packing: 'Đóng gói',
  NumberOfSmallPieces: 'Số lượng kiện nhỏ',
  SmallPiecePacking: 'Đóng gói kiện nhỏ',
  ChargeableWeightRT: 'Trọng lượng tính cước RT',
  EnglishProductName: 'Tên hàng tiếng Anh',
  ShippingMarks: 'Ký hiệu',
  HSCode: 'Mã HS',
  ChineseProductName: 'Tên hàng tiếng Trung',
  CargoSales: 'Tiếp nhận và bán hàng',
  OperatingCompany: 'Công ty thao tác',
  OperatingDepartment: 'Bộ phận thao tác',
  OperationRequirements: 'Yêu cầu thao tác',
  OperationTips: 'Gợi ý thao tác',
  AdditionalFeeTerms: 'Điều khoản phụ phí',
  WarehouseEntryInformation: 'Thông tin nhập kho',
  Remarks: 'Ghi chú',
  CustomField4: 'Trường tùy chỉnh 4',
  Shipper: 'Người gửi hàng',
  SecondNotifyParty: 'Người thông báo thứ hai',
  EntrustedInformation: 'Thông tin ủy thác',
  VipCooperativeCustomer: 'Khách hàng hợp tác VIP',
  DetailedInformation: 'Thông tin chi tiết',
  Transshipment: 'Quá cảnh',
  AdditionalInformation: 'Thông tin bổ sung',
  DoorToDoorLoadingCollection: 'Đóng hàng tại điểm/Nhận hàng',
  SelfPickupSelfDelivery: 'Tự vận chuyển',
  AutomaticAllocation: 'Phân phối tự động',
  WarehousingInformation: 'Nhận hàng vào kho',
  CargoBoxInformation: 'Thông tin hàng hóa',
  OperationInformation: 'Thông tin thao tác',
  CustomInformation: 'Thông tin tùy chỉnh',
  CustomerShippingInformation: 'Thông tin vận chuyển của khách hàng',
  CodeRetrieval: 'Tìm kiếm mã',
  OperationCannotBeEmpty: 'Thao tác không được để trống',
  OperationDepartmentCannotBeEmpty: 'Bộ phận thao tác không được để trống',
  OperationBranchCannotBeEmpty: 'Chi nhánh thao tác không được để trống',
  DesignatedFreightAgent: 'Đại lý hàng chỉ định',
  DeparturePortAgent: 'Đại lý cảng đi',
  Client: 'Đơn vị ủy thác',
  DeclaringCustoms: 'Có khai báo hải quan không',
  ContainerPackingWarehouse: 'Đóng hàng nội bộ/Kho bãi',
  WarehouseService: 'Có lưu kho không',
  PricingNature: 'Tính chất giá ước tính',
  BookingNature: 'Tính chất đặt chỗ',
  PleaseARecordToView: 'Vui lòng chọn một bản ghi để xem',
  WriteOff: 'Xác nhận tất cả',
  AgeOfAccount: 'Tuổi nợ hóa đơn',
  CommissionAmount: 'Số tiền hoa hồng',
  TradeType: 'Loại hình giao dịch',
  PayableWriteOffStatus: 'Tình trạng thanh toán phải trả',
  ReceivableWriteOffStatus: 'Tình trạng thanh toán phải thu',
  Date: 'Ngày tháng',
  PleaseEnterTheReviewDate: 'Vui lòng nhập ngày kiểm duyệt',
  PleaseConfirmTheReviewDate: 'Vui lòng xác nhận ngày kiểm duyệt',
  FailedToGetDetails: 'Lấy thông tin chi tiết thất bại',
  AfterForFinancialReviewContinue: 'Sau khi in bảng phân tích lợi nhuận, đơn này sẽ được gửi để kiểm duyệt tài chính và không thể thay đổi. Bạn có muốn tiếp tục?',
  Warning: 'Cảnh báo',
  PleaseNumberBeforePrintingTable: 'Vui lòng nhập số container sau đó in bảng phân tích lợi nhuận.',
  PleaseSelectCost: 'Vui lòng chọn chi phí',
  ConfirmTheSingleCostDate: 'Bạn có chắc muốn sửa ngày tài chính cho chi phí đơn lẻ này?',
  CostFinancialDateModificationSuccessful: 'Sửa ngày tài chính chi phí thành công',
  ConfirmModifyTheFinancialDate: 'Bạn có chắc muốn sửa ngày tài chính?',
  FinancialDateModificationSuccessful: 'Sửa ngày tài chính thành công',
  ReviewBusinessDateDoContinue: 'Ngày kiểm duyệt nhỏ hơn ngày nghiệp vụ, bạn có muốn tiếp tục?',
  ConfirmReviewOfTheseOrders: 'Bạn có chắc muốn kiểm duyệt những đơn này?',
  ThisIsNotIn: 'Nghiệp vụ này không phải trạng thái [',
  AllowedToReviewCheck: '], không được phép kiểm duyệt, vui lòng kiểm tra!',
  ConfirmToAllowAmendments: 'Bạn có chắc muốn cho phép sửa đơn?',
  AmendmentAllowedSuccessful: 'Cho phép sửa đơn thành công',
  NoOrNotInStatus: 'Chưa chọn chi phí hoặc không phải trạng thái kiểm duyệt',
  ConfirmCancellationOfReview: 'Bạn có chắc muốn hủy kiểm duyệt?',
  CostStatusUpdateSuccessful: 'Cập nhật trạng thái chi phí thành công',
  NoOrNotInStatus2: 'Chưa chọn chi phí hoặc không phải trạng thái gửi',
  NoOrNotInStatus3: 'Chưa chọn chi phí hoặc không phải trạng thái kiểm duyệt!',
  NoOrNotInStatus4: 'Chưa chọn chi phí hoặc không phải trạng thái gửi!',
  ConfirmToCancelReview: 'Bạn có chắc muốn hủy kiểm duyệt?',
  CancelReviewSuccessful: 'Hủy kiểm duyệt thành công',
  LCLIndividuallyPleaseReviewBill: 'Vé lẻ hàng ghép không thể kiểm duyệt riêng, vui lòng kiểm duyệt vé chính.',
  FrontEndErrorCallbackFailed: 'Lỗi frontend: callback thất bại',
  CostStatusUpdateSuccessful2: 'Cập nhật trạng thái chi phí thành công.',
  PleaseStaffInformationBeforePrinting: 'Vui lòng nhập thông tin nhân viên bán hàng trước khi in!',
  TheNotEnteredSales: '以下几单没有输入销售人员信息：\n',
  PleaseEnterBeforePrinting: '\n请输入后再打印！',
  PleaseWantToModifyDate: 'Vui lòng chọn nghiệp vụ cần sửa ngày',
  BusinessDateModificationSuccessful: 'Sửa ngày nghiệp vụ thành công',
  PleaseSelectOnlyOneRecord: 'Vui lòng chỉ chọn một bản ghi',
  InvoicePool_OnlyWithAttachment: 'Có tệp đính kèm',
  PleaseSelectBusiness: 'Vui lòng chọn nghiệp vụ.',
  SelectedDataIncludes: 'Dữ liệu được chọn bao gồm',
  StatusAllowedToReviewCheck: 'nghiệp vụ ở trạng thái không được phép kiểm duyệt, vui lòng kiểm tra!',
  StatusToCancelReviewCheck: 'nghiệp vụ ở trạng thái không được phép hủy kiểm duyệt, vui lòng kiểm tra!',
  BatchReviewFailed: 'Kiểm duyệt hàng loạt thất bại',
  ReviewLessThanBusinessContinue: 'Ngày kiểm duyệt nhỏ hơn ngày nghiệp vụ, có tiếp tục không?',
  ConfirmToReviewTheseOrders: 'Bạn có chắc muốn kiểm duyệt những đơn này?',
  FinancialReviewList: 'Danh sách kiểm duyệt tài chính',
  QueryFailed: 'Truy vấn thất bại',
  PleaseBusinessYouWantPrint: 'Vui lòng chọn nghiệp vụ cần in',
  SendEmail: 'Gửi email',
  N1ContactAndEmailMaintained: '1. Danh bạ và email chưa được duy trì:',
  N1AMaintainedContactEmail: '1. Vui lòng chọn danh bạ và email đã được duy trì:',
  N2PleaseAddOtherEmails: '2. Vui lòng bổ sung email khác:',
  MultipleShouldBeSeparatedCommas: '(Nhiều địa chỉ email cách nhau bằng dấu phẩy)',
  Send: 'Gửi',
  InvoiceUuidCannotBeEmpty: 'UUID hóa đơn không được để trống!',
  SettlementIdCannotBeEmpty: 'ID đơn vị thanh toán không được để trống!',
  PleaseEnterEmail: 'Vui lòng nhập email',
  SendLog: 'Nhật ký gửi',
  Sender: 'Người gửi',
  YouViewOtherPeoplesFiles: 'Bạn không có quyền xem file người khác tải lên hoặc in.',
  CostName: 'Tên chi phí',
  PaymentType: 'Loại thu chi',
  BillingExchangeRate: 'Tỷ giá hóa đơn',
  BillingAmount: 'Số tiền hóa đơn',
  BillBusinessNumber: 'Số hóa đơn/nghiệp vụ',
  BillBusinessDate: 'Ngày hóa đơn/nghiệp vụ',
  PriceExclusiveOfTax: 'Giá chưa thuế',
  ResetColumn: 'Đặt lại cột',
  OnlyNumberCanBeSelected: 'Chỉ được chọn 1 số hóa đơn!',
  Used: 'Đã sử dụng',
  Example8180onlyUSDIsInvoice: 'VD: USD:355/Tỷ giá:6.8180/Hóa đơn này chỉ thu USD',
  PleaseNote: 'Lưu ý:',
  ChangesTheNextInvoiceConfiguration: 'Cấu hình có hiệu lực từ hóa đơn tiếp theo sau khi lưu',
  EBeLessThanCharacters: 'Ghi chú hóa đơn điện tử phải dưới 100 ký tự',
  PaperBeLessThanCharacters: 'Ghi chú hóa đơn giấy phải dưới 200 ký tự',
  AutomaticTheTextDoesntLine: 'Tự động xuống dòng khi không hiển thị hết',
  PDFDisplayUpToLines: 'Ghi chú hóa đơn PDF tối đa 3 dòng',
  InvoiceType: 'Loại hóa đơn',
  RMBExpenseItemName: 'Tên khoản chi RMB',
  USDExpenseItem: 'Khoản chi USD',
  DefaultItemName: 'Có phải tên mặc định?',
  Billing: 'Lập hóa đơn',
  Add: 'Thêm mới',
  InternationalFreightForwardingFee: 'Cước vận chuyển đại lý quốc tế',
  InternationalShippingFee: 'Cước biển đại lý quốc tế',
  InternationalFreightServiceFee: 'Phí dịch vụ giao nhận quốc tế',
  FreightForwardingFee: 'Phí đại lý vận tải',
  MarkBill: 'Đánh dấu hóa đơn',
  MarkCharge: 'Đánh dấu chi phí',
  MarkJob: 'Đánh dấu nghiệp vụ',
  PleaseSelectChargeToMark: 'Vui lòng chọn chi phí cần đánh dấu.',
  MarkRecordExistsMarkedCharge: 'Trong bản ghi có chi phí đã được đánh dấu, vui lòng chọn chi phí chưa đánh dấu.',
  PleaseSelectJobToMark: 'Vui lòng chọn nghiệp vụ cần đánh dấu.',
  MarkRecordExistsMarkedJob: 'Trong bản ghi có nghiệp vụ đã được đánh dấu, vui lòng chọn nghiệp vụ chưa đánh dấu.',
  MarkRecordExistsNoMarkedCharge: 'Trong bản ghi có chi phí chưa được đánh dấu, vui lòng chọn chi phí đã đánh dấu.',
  MarkRecordExistsNoMarkedJob: 'Trong bản ghi có nghiệp vụ chưa được đánh dấu, vui lòng chọn nghiệp vụ đã đánh dấu.',
  AnnotationDate: 'Ngày đánh dấu:',
  Annotator: 'Người đánh dấu:',
  InvoiceInquiry: 'Tra cứu hóa đơn',
  QuickSearchInvoiceNumber: 'Tìm nhanh: Số hóa đơn',
  SecondaryDownload: 'Lần tải xuống',
  Sent: 'Đã gửi',
  Unsent: 'Chưa gửi',
  Total: 'Tổng cộng',
  VoidingBulkOperationsPleaseSelectClickVoid: 'Hủy hóa đơn không hỗ trợ thao tác hàng loạt\nVui lòng chọn 1 hóa đơn rồi bấm [Hủy]',
  OriginalToReissueTheExpenses: 'Chi phí gốc sẽ bị điều chỉnh giảm, nếu cần lập lại hóa đơn, hãy thêm chi phí chính xác!',
  OriginalTheSystemWillExpenses: 'Chi phí gốc sẽ bị điều chỉnh giảm, hệ thống tự tạo chi phí giống ban đầu!',
  CreditSuccess: 'Hồng trừ thành công!',
  BankAccount: 'Tài khoản ngân hàng',
  OnlyElectronicInvoicesPleaseType: 'Chỉ hỗ trợ tải hàng loạt hóa đơn điện tử, vui lòng kiểm tra loại hóa đơn.',
  TotalSelection: 'Tổng đã chọn',
  StatusUnknown: 'Trạng thái không xác định',
  UnwrittenAmount: 'Số tiền chưa thanh toán',
  WrittenOffAmount: 'Số tiền đã thanh toán',
  SearchByExpense: 'Tìm kiếm theo chi phí',
  QuickSearchBusinessNumber: 'Tìm nhanh: Số nghiệp vụ',
  SearchByBusiness: 'Tìm kiếm theo nghiệp vụ',
  SearchByBill: 'Tìm kiếm theo hóa đơn',
  QuickSearchBillNumber: 'Tìm nhanh: Số hóa đơn',
  SearchByReconciliationBill: 'Tìm kiếm theo đối chiếu',
  QuickSearchReconciliationBillNumber: 'Tìm nhanh: Số đối chiếu',
  SearchByExpenseCredit: 'Tìm kiếm theo chi phí (hồng trừ)',
  SearchByBusinessCredit: 'Tìm kiếm theo nghiệp vụ (hồng trừ)',
  SearchByBillCredit: 'Tìm kiếm theo hóa đơn (hồng trừ)',
  SearchByReconciliationBillCredit: 'Tìm kiếm theo đối chiếu (hồng trừ)',
  SearchingYouSureYouAgo: 'Nếu phạm vi ngày được chọn lớn hơn 2 năm, sẽ ảnh hưởng đến tốc độ tải dữ liệu, bạn có chắc muốn truy vấn dữ liệu ngoài 2 năm không?',
  SelectClosingDate: 'Chọn ngày khóa sổ',
  ClosingDate: 'Ngày khóa sổ:',
  FinancialClosing: 'Khóa sổ tài chính',
  BusinessClosing: 'Khóa sổ nghiệp vụ',
  ClosingPerson: 'Người khóa sổ',
  ClosingMonth: 'Tháng khóa sổ',
  ClosingBranch: 'Chi nhánh khóa sổ',
  ClosingType: 'Loại khóa sổ',
  TheHasAlreadyBeenClosed: 'Tháng được chọn hiện tại đã được khóa sổ.',
  ClosingSuccess: 'Khóa sổ thành công',
  PleaseSelectAClosingRecord: 'Vui lòng chọn bản ghi khóa sổ.',
  TheBeenAuditedAndCancelled: 'Bản ghi khóa sổ đã được duyệt, không thể hủy.',
  AreWantToCancelRecord: 'Bạn có chắc muốn hủy bản ghi khóa sổ không?',
  ClosingRecordCancelled: 'Đã hủy bản ghi khóa sổ',
  Year: 'Năm',
  Month: 'Tháng',
  PleaseSelectARecord: 'Vui lòng chọn bản ghi.',
  AreWantToAuditRecord: 'Bản ghi khóa sổ sau khi duyệt không thể hủy, bạn có chắc không?',
  OperationSuccessful: 'Thao tác thành công.',
  ToYouSureYouAudit: 'Sau khi hủy duyệt có thể hủy ngày khóa sổ, bạn có chắc không?',
  NoMatchingPrintTemplatesFound: 'Không tìm thấy mẫu in tương ứng',
  FinancialAudit: 'Duyệt tài chính',
  HangingWaterBill: 'Phiếu treo',
  ReceivedPayment: 'Đã nhận tiền',
  GotReceipt: 'Nhận được biên lai',
  InternationalBill: 'Hóa đơn nước ngoài',
  AgencySharingBill: 'Hóa đơn chia phần đại lý',
  PaymentRequestQuery: 'Tìm kiếm yêu cầu thanh toán',
  QuickSearchPaymentRequestNumber: 'Tìm nhanh: Số yêu cầu thanh toán',
  ChangeExpenseApplicationQuery: 'Tìm kiếm yêu cầu thay đổi chi phí',
  QuickSearchApplicationSerialNumber: 'Tìm nhanh: Số thứ tự yêu cầu',
  SearchByInvoice: 'Tra cứu theo hóa đơn',
  BankAccountNumber: 'Tài khoản ngân hàng',
  NoCorrespondingPrintTemplateFound: 'Không tìm thấy mẫu in tương ứng',
  SearchByCost: 'Tra cứu theo chi phí',
  ReleasePleasePrepareForWithholding: 'Đã phát đơn, vui lòng chuẩn bị giữ hàng.',
  StatusUpdatedSuccessfully: 'Cập nhật trạng thái thành công.',
  BillOfLadingConfirmationDocument: 'Bản xác nhận vận đơn',
  DataCustomersReleaseNotAllowed: 'Dữ liệu có khách hàng trong danh sách đen, không được phát đơn!',
  AreToUseAnNumber: 'Xác nhận sử dụng số phát đơn trống?',
  Invoice: 'Lập hóa đơn',
  EquivalentToRMB: 'Quy đổi RMB:',
  ReconciliationFlowNumber: 'Số giao dịch thanh toán',
  CounterpartyUnit: 'Đơn vị đối tác',
  OurBank: 'Ngân hàng bên tôi',
  PaymentNoticeNumber: 'Số thông báo thanh toán',
  VoucherNumber: 'Số chứng từ',
  BankSlipNumber: 'Số sao kê ngân hàng',
  ReconciliationPerson: 'Người thanh toán',
  ReconciliationDate: 'Ngày thanh toán',
  ReceiptpaymentDate: 'Ngày thu/chi',
  VoucherDate: 'Ngày chứng từ',
  SlipStatus: 'Trạng thái sao kê',
  ReceiptpaymentMethod: 'Phương thức thu/chi',
  WhetherPrepaid: 'Đã thanh toán trước?',
  Amount: 'Số tiền',
  AmountReconciled: 'Số tiền đã thanh toán',
  Balance: 'Số dư',
  ActualAmountReceived: 'Số tiền thực thu',
  ActualPaymentAmount: 'Số tiền thực chi',
  FinancialExpense: 'Chi phí tài chính',
  ExchangeGainloss: 'Lãi/lỗ hối đoái',
  SmallHead: 'Chênh lệch số lẻ',
  OriginalCurrencyDifference: 'Chênh lệch tỷ giá gốc',
  Review: 'Kiểm tra lại',
  ReviewDate: 'Ngày kiểm tra lại',
  Void: 'Hủy bỏ',
  InvoiceInformation: 'Thông tin hóa đơn',
  AccountPerioddays: 'Kỳ hạn thanh toán (ngày)',
  CounterpartyVoucherNumber: 'Số chứng từ đối tác',
  VoucherDate2: 'Ngày chứng từ 2',
  FailedToModifyReconciliation: 'Sửa thanh toán thất bại',
  OffsetSearchAndSelectThe: 'Bù trừ thanh toán: Vui lòng tra cứu và chọn tất cả để bù trừ',
  Fees: 'Chi phí',
  Invoices: 'Hóa đơn',
  Statements: 'Hóa đơn thanh toán',
  AccountStatements: 'Bảng đối chiếu',
  PaymentApplications: 'Đề nghị thanh toán',
  PlatformCustomerService: 'Hỗ trợ khách hàng nền tảng',
  FailedToRevokeReconciliation: 'Hủy thanh toán thất bại',
  Equivalent: 'Quy đổi',
  PaymentAmount: 'Số tiền thanh toán',
  PaymentMethod: 'Phương thức thanh toán',
  NotUsed: 'Chưa sử dụng',
  PendingSlip: 'Treo phiếu thu',
  ReceivedReceipt: 'Nhận biên lai',
  Reconciliation: 'Xóa nợ',
  Company1: 'Công ty 1',
  CloseAndCopyFlowNumber: 'Đóng và sao chép số serial',
  Close: 'Đóng',
  CopySuccessful: 'Sao chép thành công',
  IfLoadingSpeedAreAgo: 'Nếu phạm vi ngày được chọn lớn hơn 2 năm sẽ ảnh hưởng đến tốc độ tải dữ liệu. Bạn có chắc muốn truy vấn dữ liệu ngoài 2 năm không?',
  FinancialComprehensiveQuery: 'Tra cứu tổng hợp tài chính',
  ExportEstimationForm: 'Xuất bảng dự toán',
  ExportingMailboxLaterPleaseMailbox: 'Đang xuất dữ liệu, sẽ gửi đến email người đăng nhập sau. Vui lòng kiểm tra email để xem file.',
  ChineseName: 'Tên tiếng Trung',
  ClosingRecords: 'Lịch sử đóng sổ',
  ClosingReview: 'Duyệt đóng sổ',
  PleaseCheckARecord: 'Vui lòng chọn một bản ghi.',
  PleaseAReconciliationRuleName: 'Vui lòng nhập tên quy tắc đối chiếu',
  PleaseSelectABranch: 'Vui lòng chọn chi nhánh',
  DeleteSuccessful: 'Xóa thành công',
  PleaseReconciliationRuleToEdit: 'Vui lòng chọn quy tắc đối chiếu để chỉnh sửa',
  PleaseTheMatchingFieldOrder: 'Vui lòng nhập thứ tự trường khớp',
  PleaseTheMatchingFieldName: 'Vui lòng chọn tên trường khớp',
  PleaseTheContrastFieldOrder: 'Vui lòng nhập thứ tự trường đối chiếu',
  PleaseTheContrastFieldName: 'Vui lòng chọn tên trường đối chiếu',
  PleaseTheContrastFieldOperation: 'Vui lòng chọn thao tác trường đối chiếu',
  EnterReconciliationAmount: 'Vui lòng nhập [Số tiền đối chiếu] trong bảng nội bộ, đảm bảo tổng số tiền đối chiếu được chọn ở hai bên khớp nhau trước khi thực hiện đối chiếu thủ công.',
  XNotAllowViewOrDownload: 'File {0} không cho phép bất kỳ ai xem hoặc tải xuống.',
  NoPermissionView: 'Bạn không có quyền xem hoặc tải xuống file {0}',
  SelectedNotAllowedToCheck: 'Dữ liệu được chọn có nghiệp vụ không ở trạng thái {0}, không được phép duyệt. Vui lòng kiểm tra!',
  N0isBeVoidedPleaseNote: '【{0}】 là hóa đơn điện tử không thể hủy, vui lòng điều chỉnh ngược',
  N0isCannotBeVoidedNote: '【{0}】 là hóa đơn liên tháng không thể hủy, vui lòng điều chỉnh ngược',
  N0VoidedAndCannotCredited: '{0} đã bị hủy, không thể điều chỉnh ngược!',
  N0hasOffAndCannotCredited: '{0} đã được thanh toán, không thể điều chỉnh ngược!',
  N0ItemsDownloadable: 'dòng, có thể tải xuống',
  N0ItemsConfirmDownload: 'dòng, xác nhận tải xuống?',
  TelexContact0ToApplication: 'Đã nộp đơn xin điện phóng, vui lòng liên hệ {0} để hủy yêu cầu.',
  DocumentaryStatus: 'Trạng thái lập chứng từ',
  GotIt: 'Đã hiểu',
  CurrencyConversionColumnSet: 'Thiết lập cột hiển thị loại tiền quy đổi',
  CurrencyConversionSet: 'Thiết lập loại tiền quy đổi',
  ShowColumns: 'Cột hiển thị',
  CurrencyConversionColumnSetNote: 'Lưu ý: Sau khi chọn loại tiền, hệ thống sẽ tự động tạo cột hiển thị số tiền gốc hoặc số tiền chi phí quy đổi sang loại tiền đó',
  CheckAtLeastOneDisplayColumn: 'Vui lòng chọn ít nhất một cột hiển thị.',
  InvoiceWrittenOffWantDeleteIt: 'Hóa đơn đã được thanh toán, xác nhận xóa?',
  InvoiceWrittenOffWantRevokedIt: 'Hóa đơn đã được thanh toán, xác nhận hủy?',
  InvoiceWrittenOffWantRedPunchIt: 'Hóa đơn đã được thanh toán, xác nhận điều chỉnh ngược?',
  RedPunchInvoice: 'Hóa đơn điều chỉnh ngược',
  BatchCheckRedFlushInvoiceMessageOne: '1. Nếu chọn lập hóa đơn sai, hệ thống sẽ tự động tạo chi phí mới chờ lập hóa đơn theo chi phí gốc',
  BatchCheckRedFlushInvoiceMessageTwo: '2. Nếu chọn chấm dứt dịch vụ, giảm giá bán hoặc trả lại hàng bán, vui lòng nhập lại thủ công chi phí chính xác',
  BatchCheckRedFlushInvoiceMessageThree: '2. Nếu chọn chấm dứt dịch vụ hoặc giảm giá bán, vui lòng nhập lại thủ công chi phí chính xác',
  IncorrectInvoiceInformation: 'Thông tin hóa đơn không chính xác',
  IncorrectChargeInformation: 'Thông tin chi phí không chính xác',
  BatchCheckRedPunchInvoiceMessageOne: '1. Nếu chọn thông tin hóa đơn không chính xác, hệ thống sẽ tự động tạo chi phí mới chờ xuất hóa đơn dựa trên chi phí ban đầu',
  BatchCheckRedPunchInvoiceMessageTwo: '2. Nếu chọn thông tin chi phí không chính xác, vui lòng nhập lại thủ công chi phí chính xác',
  ContinueRedPunchAtVoucher: 'Số hóa đơn đã tạo chứng từ, xác nhận có hủy bỏ không?',
  WhtDeduction: 'Khấu trừ WHT',
  WhtDeductionAmount: 'Mức khấu trừ WHT',
  ReceivableWHTTaxAmount: 'Phải thu trừ thuế WHT',
  PayableWHTTaxAmount: 'Phải trả trừ thuế WHT',
  TotalExcludingTax: 'Tổng cộng (chưa thuế)',
  TotalIncludingTax: 'Tổng cộng (đã thuế)',
  NewGeneration: 'Trạng thái đẩy sang hệ thống mới',
  PushState: 'Trạng thái đẩy',
  PushFailReason: 'Push thất bại',
  ManualMatching: 'Ghép thủ công',
  SelectBusinessNumber: 'Chọn mã nghiệp vụ tương ứng',
  ManualMatchByBoxNo: 'Ghép thủ công theo số container',
  ManualMatchByWarehouseNo: 'Ghép thủ công theo mã nhập kho',
  FreeMatch: 'Ghép tự do',
  SelectSameSupplierNumberMatch: 'Vui lòng chọn cùng mã nhà cung cấp để ghép thủ công.',
  BusinessNoMblSoNoNotEmpty: 'Mã nghiệp vụ, số vận đơn chính và SO NO không được để trống',
  SelectCorrespondeBusiness: 'Vui lòng chọn nghiệp vụ tương ứng',
  CostSyncColudStatus: 'Trạng thái đồng bộ chi phí lên nền tảng đám mây',
  SyncCloudExceptionReason: 'Lý do đồng bộ nền tảng đám mây bất thường',
  ManualSynchronization: 'Đồng bộ thủ công',
  SelectNotSyncManualPush: 'Vui lòng chọn dữ liệu có trạng thái đồng bộ là chưa đồng bộ để đẩy thủ công',
  SyncChargeNotSplit: 'Chi phí đã đồng bộ không thể tách',
  SyncCloudPlatformStatus: 'Trạng thái đồng bộ nền tảng đám mây',
  InvoiceNoEmptyNotPush: 'Số hóa đơn trống, không thể đẩy',
  InvoicePushNotAgain: 'Hóa đơn đã đẩy, không đẩy trùng',
  SentYongYouRedFlush: 'Đã đẩy sang U8, vui lòng thực hiện thao tác hủy bỏ',
  InvoiceTitleNotSync: 'Tiêu đề hóa đơn "{0}" chưa đồng bộ U8, vui lòng đồng bộ trước.',
  OnlySupportInternal: 'Giao diện không bao gồm chi phí nước ngoài, vui lòng chọn hóa đơn nội địa.',
  NotSupportMultiCurrency: 'Tồn tại nhiều loại tiền tệ hóa đơn, không thể đẩy U8. Vui lòng điều chỉnh dữ liệu.',
  OnlySupportRmb: 'Loại tiền hóa đơn không phải RMB, không thể đẩy U8.',
  PayableInvoiceActualReceiptDateEmpty: 'Ngày nhận hóa đơn thực tế không được để trống, vui lòng điền trước',
  PushYongYouInvoiceNeedRMB: 'Đẩy hóa đơn U8 yêu cầu loại tiền hóa đơn là RMB',
  OffsetRedPunchTipU8C: 'Theo yêu cầu tập đoàn, hóa đơn hủy không thể đẩy, vui lòng xử lý offline',
  AccountsReceivable: 'Phải thu:',
  PayableColon: 'Phải trả:',
  PrintByAccountNumber: 'In theo số hóa đơn',
  PrintAccordingAccountNumber: 'In theo số đối chiếu',
  PrintByPaymentRequestNumber: 'In theo số yêu cầu thanh toán',
  PushUFIDANeedReceiptDate: 'Để đẩy hệ thống chứng từ U8, hóa đơn phải trả cần điền ngày nhận thực tế',
  WhenShareFinanceCost: '(Khi phân bổ chi phí tài chính)',
  ReceivablesVerificationStatus: 'Trạng thái kiểm tra công nợ',
  UnlockLedgerBatchNo: 'Số lô',
  UnlockLedgerApplyUser: 'Người yêu cầu',
  UnlockLedgerStatus: 'Trạng thái',
  UnlockLedgerOrderCount: 'Số đơn',
  UnlockLedgerDeclaredImpact: 'Ảnh hưởng lãi gộp khai báo',
  UnlockLedgerBeforeProfit: 'Lãi gộp trước mở khóa',
  UnlockLedgerAfterProfit: 'Lãi gộp sau mở khóa',
  UnlockLedgerActualImpact: 'Ảnh hưởng lãi gộp thực tế',
  UnlockLedgerRelockTime: 'Thời gian khóa lại tự động',
  UnlockLedgerApplyTime: 'Thời gian gửi',
  UnlockLedgerStatus0: 'Đang phê duyệt',
  UnlockLedgerStatus1: 'Đang mở khóa',
  UnlockLedgerStatus2: 'Đã khóa lại',
  UnlockLedgerStatus3: 'Đã từ chối',
  UnlockLedgerManualRemarks: 'Ghi chú khóa thủ công',
  UnlockLedgerStatus9: 'Bất thường',
  UnlockLedgerDetailTitle: 'Chi tiết yêu cầu mở khóa',
  UnlockLedgerApplyInfo: 'Thông tin yêu cầu',
  UnlockLedgerSpNo: 'Số phê duyệt WeCom',
  UnlockLedgerUnlockTime: 'Thời gian mở khóa xong',
  UnlockLedgerPlanRelockTime: 'Thời gian khóa lại dự kiến',
  UnlockLedgerActualRelockTime: 'Thời gian khóa lại thực tế',
  UnlockLedgerFailReason: 'Nguyên nhân bất thường',
  UnlockLedgerJobs: 'Ảnh chụp đơn hàng',
  UnlockLedgerJobNo: 'Số đơn',
  UnlockLedgerCustomerName: 'Tên khách hàng',
  UnlockLedgerBeforeReceivable: 'Phải thu trước mở khóa',
  UnlockLedgerBeforePayable: 'Phải trả trước mở khóa',
  UnlockLedgerAfterReceivable: 'Phải thu sau khóa lại',
  UnlockLedgerAfterPayable: 'Phải trả sau khóa lại',
  UnlockLedgerDiffTab: 'Chi tiết khác biệt phí',
  UnlockLedgerJobFilter: 'Lọc theo đơn',
  UnlockLedgerChargeName: 'Tên phí',
  UnlockLedgerChangeType: 'Loại thay đổi',
  UnlockLedgerChangeType0: 'Thêm',
  UnlockLedgerChangeType1: 'Sửa',
  UnlockLedgerChangeType2: 'Xóa',
  UnlockLedgerFieldChanges: 'Trường thay đổi',
  UnlockLedgerModifyUser: 'Người sửa',
  UnlockLedgerModifyTime: 'Thời gian sửa',
  UnlockLedgerDiffEmptyTip: 'Chưa có chi tiết khác biệt (khác biệt phí phát sinh khi khóa lại)',
  UnlockLedgerTip: 'Sửa phí của đơn đã khóa cần mở khóa qua phê duyệt WeCom; sau khi phê duyệt sẽ tự động mở khóa và tự động khóa lại lúc 01:00 sau 3 ngày; mọi khác biệt được lưu vết'
}
